export default function Loader({ className }) {
  return (
    <div
      className={`fixed inset-0 bg-[rgba(0,0,0,0.5)] z-50 w-full h-screen justify-center items-center ${className}`}
    >
      <div className="border-4 border-gray-200 border-t-transparent rounded-full animate-spin h-8 w-8"></div>
    </div>
  );
}
